module.exports = __webpack_public_path__ + "stylesheets/comments_617675bfb2cd10445614323cb480cfa3.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/comments.less
// module id = +goU
// module chunks = 153